module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Fish-29a2b3f513317b4b502aa96b3e2528ec82418ca553f8d15b5d471aac1e4441db.svg";